import { Stack, Typography } from '@mui/material';

const HeaderText = () => {

  return (
    <Stack direction='row' gap={1} >
      <Stack flexBasis='50%'>
        <Typography sx={{
          fontFamily:'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom:'12px',
        }}>Full Names</Typography>
      </Stack>
      <Stack flexBasis='50%'>
        <Typography sx={{
          fontFamily:'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom:'12px',
        }}>Email Address</Typography>
      </Stack>
      <Stack flexBasis='25%'>
        <Typography sx={{
          fontFamily:'Schibsted Grotesk, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          color: '#181818',
          lineHeight: '125%',
          marginBottom:'12px',
        }}>Department</Typography>
      </Stack>
    </Stack>
  );
};

export default HeaderText;